import { inject, Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { RecaptchaConfiguration } from '../type/recaptcha.type';
import { ReCaptchaConfigService } from './recaptcha-config.service';
import { ReCaptchaV3Service } from './recaptcha_v3.service';

@Injectable({ providedIn: 'root' })
export class ReCaptchaService {
  private readonly configService = inject(ReCaptchaConfigService);
  private readonly captchaV3Service = inject(ReCaptchaV3Service);

  /**
   * Execute {@link executeAsPromise#executeAsPromise} with siteKey loaded from the {@link ReCaptchaConfigService} and return the token via Observable.
   *
   * @param action Action to log
   * @param config Optional configuration like useGlobalDomain to be provided
   */
  executeAsObservable(action: string, config?: RecaptchaConfiguration): Observable<string> {
    return this.configService.withConfig(c => from(this.captchaV3Service.executeAsPromise(c.siteKey, action, config)));
  }
}
